import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader.tsx'
import { KnowledgeDetailPage } from '#features/knowledge/knowledge-detail-page.tsx'

export const Route = createFileRoute(
  '/_app/$workspace/_dashboard/knowledge/$id',
)({
  component: RouteComponent,
  pendingComponent: DefaultLoader,
})

function RouteComponent() {
  const params = Route.useParams()
  return <KnowledgeDetailPage observationId={params.id} />
}
